import { ArrowLeft, BarChart3, Phone, ShieldCheck, Zap } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';

import Logo from '@/components/common/Logo';
import { Badge } from '@/components/ui';
import { ROUTES } from '@/utils/constants';

const HIGHLIGHTS = [
  { icon: Phone, text: 'Mobile + OTP login, no password needed' },
  { icon: Zap, text: 'Remember me keeps you in for 12 hours' },
  { icon: ShieldCheck, text: 'Role-based access · full audit trail' },
  { icon: BarChart3, text: 'Live MIS dashboards, no exports needed' },
];

const AuthLayout = () => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="relative hidden flex-col justify-between overflow-hidden border-r border-line p-12 lg:flex">
      <div className="bg-grid pointer-events-none absolute inset-0" />

      <div className="relative">
        <Logo />
      </div>

      <div className="relative">
        <Badge variant="info" className="normal-case">
          Internal CRM
        </Badge>
        <h2 className="mt-4 max-w-lg text-4xl font-extrabold leading-[1.1] tracking-tight text-ink">
          Fast mobile + OTP sign-in for the AdvisorKhoj team.
        </h2>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-ink/60">
          No passwords to remember. Enter your registered mobile, verify with a one-time code, and
          you&apos;re in.
        </p>
        <ul className="mt-8 max-w-md space-y-3">
          {HIGHLIGHTS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-sm text-ink">
              <span className="grid h-8 w-8 place-items-center rounded-lg border border-brand/20 bg-brand-tint text-brand">
                <Icon className="h-4 w-4" />
              </span>
              {text}
            </li>
          ))}
        </ul>
      </div>

      <p className="relative text-xs text-ink/60">
        ©{new Date().getFullYear()} AdvisorKhoj · Internal CRM
      </p>
    </div>

    <div className="relative flex flex-col bg-white p-4 lg:p-8">
      <Link
        to={ROUTES.LANDING}
        className="z-10 -mr-2 inline-flex min-h-11 items-center gap-1 self-end rounded-md px-2 text-sm text-ink/60 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand lg:absolute lg:right-8 lg:top-8 lg:mr-0 lg:min-h-0 lg:self-auto lg:px-0"
      >
        <ArrowLeft className="h-4 w-4" /> Back to landing
      </Link>

      <div className="mb-6 mt-2 lg:hidden">
        <Logo />
      </div>

      <div className="flex flex-1 items-center justify-center py-6">
        <Outlet />
      </div>
    </div>
  </div>
);

export default AuthLayout;
